// Personal Growth Journey Template
export const personalGrowthTemplate = {
  id: 'personalGrowth',
  title: 'Personal Growth Journey',
  description: 'Perfect for overcoming personal limitations, developing new skills, changing perspectives, or building confidence',
  sections: [
    {
      id: 'opening_scene',
      label: 'Opening Scene',
      type: 'opening',
      prompt: 'Drop us into the exact moment you realized you needed to change or grow.',
      coachVoice: "Don't start with 'Ever since I was little...' Start with drama. What's the exact moment when you knew this wasn't going to be easy?",
      sample: "The hospital waiting room smelled like disinfectant and fear. My phone buzzed with another text from my chemistry teacher asking where my lab report was, but all I could think about was my mom's surgery and how I was supposed to keep everything together.",
      minWords: 80,
      unlockWords: 40
    },
    {
      id: 'the_real_stakes',
      label: 'The Real Stakes',
      type: 'stakes',
      prompt: 'Why did this challenge hit different for YOU specifically?',
      coachVoice: "I don't want to hear 'it was stressful.' Tell me why this particular situation pushed you beyond what you thought you could handle.",
      sample: "This wasn't just about managing stress or time - it was about becoming the reliable person my family needed while not letting my academic reachs slip away. I'd never been the responsible one before; that was always my older brother's role.",
      minWords: 80,
      unlockWords: 40
    },
    {
      id: 'your_problem_solving',
      label: 'Your Problem-Solving Style',
      type: 'approach',
      prompt: 'How did YOUR brain tackle this? Show me your unique approach.',
      coachVoice: "This is where I want to see how your mind works differently from everyone else's. What did you try that your friends wouldn't have thought of?",
      sample: "While other people might have made lists or asked for extensions, I created what I called 'micro-moments' - five minute pockets throughout each day where I'd tackle one small thing, whether it was texting an update to relatives or reviewing chemistry notes. It was like treating each day as a puzzle where every piece had to fit perfectly.",
      minWords: 100,
      unlockWords: 50
    },
    {
      id: 'proof_of_growth',
      label: 'Proof of Growth',
      type: 'growth',
      prompt: "Don't tell me you grew - prove it with a specific example.",
      coachVoice: "I need concrete evidence. Give me a scene from recently that shows this change in action.",
      sample: "Six months later, when my friend Sarah was overwhelmed with her parents' divorce and failing calculus, I found myself automatically breaking down her problems into manageable pieces. I realized I'd become someone who sees solutions where others see chaos.",
      minWords: 80,
      unlockWords: 40
    }
  ]
};